var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00B059"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8462 22C13.7094 21.9995 13.5742 21.9686 13.4489 21.9092C13.3237 21.8498 13.211 21.7631 13.118 21.6546L8.27037 16.0742C8.08916 15.8652 7.99209 15.5869 8.00051 15.3004C8.00892 15.014 8.12214 14.7429 8.31526 14.5468C8.50838 14.3507 8.76557 14.2457 9.03026 14.2548C9.29495 14.2639 9.54545 14.3864 9.72666 14.5954L13.8362 19.3339L22.2248 9.40354C22.3099 9.28882 22.4158 9.19415 22.536 9.12534C22.6562 9.05653 22.7881 9.01502 22.9236 9.00338C23.0592 8.99174 23.1955 9.01021 23.3242 9.05765C23.4528 9.10508 23.5712 9.18049 23.672 9.27924C23.7728 9.37799 23.8539 9.49799 23.9102 9.63187C23.9666 9.76576 23.9971 9.9107 23.9998 10.0578C24.0025 10.2049 23.9774 10.351 23.926 10.4873C23.8747 10.6235 23.7981 10.7469 23.7011 10.8499L14.5843 21.6438C14.4922 21.7543 14.3799 21.843 14.2546 21.9043C14.1293 21.9656 13.9936 21.9981 13.8561 22H13.8462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccessIcon);
export default __webpack_public_path__ + "static/media/alert-success-icon.3f47285b7b9395696ad02f929dbdbc39.svg";
export { ForwardRef as ReactComponent };